import * as yup from 'yup';
import { CHAT_ICON_CONFIG } from '@src/containers/BusinessManager/const';
import { validateUrl } from '../constants';

export const sdkConfigurationSchema = yup.object().shape({
  baseUrl: yup.string(),
  botType: yup.string(),
  businessActive: yup.bool(),
  businessIcon: yup.string(),
  buttonText: yup.string(),
  composerPlaceholder: yup.string(),
  customButton: yup.bool(),
  customButtonIdentifier: yup.string(),
  customSignup: yup.bool(),
  customSignupIdentifier: yup.string(),
  disabled: yup.array().of(yup.string()),
  fontFamily: yup.string(),
  fontSize: yup.string(),
  headerText: yup.string(),
  mode: yup.string(),
  chatIconConfig: yup
    .object()
    .shape({
      type: yup.string(),
      data: yup.object().shape({
        imageURL: yup.string(),
      }),
    })
    .test('prompt chat icon test', function validateChatIconData(value) {
      const { path, createError } = this;
      if (
        value.type === CHAT_ICON_CONFIG.IMAGE &&
        !value.data.imageURL.trim()
      ) {
        return createError({
          path,
          message:
            'For a chat icon with image option, please upload an image/gif.',
        });
      }
      return true;
    }),
  primaryColor: yup.string(),
  showHaptikBranding: yup.bool(),
  widgetPositioning: yup.string(),
});

// This validation schema is for business manager v2
export const sdkConfigurationSchemaV2 = yup.object().shape({
  chatIconConfig: yup
    .object()
    .shape({
      type: yup.string(),
      data: yup.object().shape({
        imageURL: yup.string(),
      }),
    })
    .test('prompt chat icon test', function validateChatIconData(value) {
      const { path, createError } = this;
      if (
        value.type === CHAT_ICON_CONFIG.IMAGE &&
        !value.data.imageURL.trim()
      ) {
        return createError({
          path,
          message:
            'For a chat icon with image option, please upload an image/gif.',
        });
      }
      return true;
    }),
  botPromptSoundUrl: yup
    .object()
    .shape({
      type: yup.string(),
      data: yup.object().shape({
        audioURL: yup.string(),
      }),
    })
    .test('bot prompt sound test', function validateNotificationSound(value) {
      const { path, createError } = this;
      if (value.type === 'custom' && !value.data.audioURL.trim()) {
        return createError({
          path,
          message:
            'For enabling bot prompt sound with custom audio, please upload an audio file.',
        });
      }
      return true;
    }),
  messageNotificationSoundUrl: yup
    .object()
    .shape({
      type: yup.string(),
      data: yup.object().shape({
        audioURL: yup.string(),
      }),
    })
    .test(
      'message notification sound test',
      function validateMessageNotificationSound(value) {
        const { path, createError } = this;
        if (value.type === 'custom' && !value.data.audioURL.trim()) {
          return createError({
            path,
            message:
              'For enabling message notification sound with custom audio, please upload an audio file.',
          });
        }
        return true;
      }
    ),
  whiteListedDomains: yup
    .array()
    .of(yup.string())
    .test('how are you', function validateCors(value) {
      const { path, createError } = this;
      console.log('agrawal', value);
      for (let i = 0; i < value.length; i++) {
        if (!validateUrl(value[i])) {
          return createError({
            path,
            message: 'CORS Whitelisted Domain Format is incorrect',
          });
        }
      }

      return true;
    }),
  omnichannelWidget: yup.array().of(
    yup.object().shape({
      type: yup.string(),
      enabled: yup.bool(),
      whatsapp_number: yup
        .string()
        .when(['type', 'enabled'], (type, enabled, schema) => {
          if (type === 'whatsapp' && enabled) {
            return schema.required('Whatsapp number is required');
          }
          return schema.notRequired();
        }),
      page_name: yup
        .string()
        .when(['type', 'enabled'], (type, enabled, schema) => {
          if (type === 'messenger' && enabled) {
            return schema.required('Facebook Page name is required');
          }
          return schema.notRequired();
        }),
      username: yup
        .string()
        .when(['type', 'enabled'], (type, enabled, schema) => {
          if (type === 'instagram' && enabled) {
            return schema.required('Instagram Username is required');
          }
          return schema.notRequired();
        }),
    })
  ),
});
